interface MatrixRow {
  name: string;
  title: string;
}

export const columnsMatrix: MatrixRow[] = [
  {
    name: 'matrixId',
    title: 'ID',
  },
  {
    name: 'title',
    title: 'Matrix Title',
  },
  { name: 'delete', title: '' },
];
